"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var guard_exports = {};
__export(guard_exports, {
  hasKey: () => hasKey,
  hasKeyOfAnyType: () => hasKeyOfAnyType,
  hasOptionalKey: () => hasOptionalKey,
  hasTypeTag: () => hasTypeTag,
  isArray: () => isArray,
  isArrayOf: () => isArrayOf,
  isBoolean: () => isBoolean,
  isExactly: () => isExactly,
  isInteger: () => isInteger,
  isLabeled: () => isLabeled,
  isNonEmptyArray: () => isNonEmptyArray,
  isNonEmptyArrayOf: () => isNonEmptyArrayOf,
  isNonNullable: () => isNonNullable,
  isNull: () => isNull,
  isNullable: () => isNullable,
  isNumber: () => isNumber,
  isObject: () => isObject,
  isOneOf: () => isOneOf,
  isOptional: () => isOptional,
  isRecordOf: () => isRecordOf,
  isString: () => isString,
  isTupleOf: () => isTupleOf,
  isUndefinable: () => isUndefinable,
  isUndefined: () => isUndefined,
  isUnion: () => isUnion,
  isUnknown: () => isUnknown
});
module.exports = __toCommonJS(guard_exports);
var import_lodash = require("lodash");
function isObject(value) {
  return typeof value === "object" && value != null;
}
function hasKeyOfAnyType(value, key) {
  return typeof value === "object" && value != null && key in value;
}
function hasKey(value, key, guard) {
  return hasKeyOfAnyType(value, key) && guard(value[key]);
}
function hasOptionalKey(value, key, guard) {
  return hasKeyOfAnyType(value, key) ? guard(value[key]) || isUndefined(value[key]) : isObject(value);
}
function hasTypeTag(value, type) {
  return hasKeyOfAnyType(value, "type") && value.type === type;
}
function isLabeled(type, isA) {
  return (value) => {
    return isObject(value) && hasTypeTag(value, type) && isA(value);
  };
}
function isExactly(target) {
  return (value) => (0, import_lodash.isEqual)(value, target);
}
function isUnknown(_value) {
  return true;
}
function isUndefined(value) {
  return value === void 0;
}
function isNull(value) {
  return value === null;
}
function isBoolean(value) {
  return typeof value === "boolean";
}
function isInteger(value) {
  return typeof value === "number" && Number.isInteger(value);
}
function isNumber(value) {
  return typeof value === "number";
}
function isString(value) {
  return typeof value === "string";
}
function isUnion(isA, isB) {
  return function(value) {
    return isA(value) || isB(value);
  };
}
function isOneOf(...values) {
  return function(value) {
    return values.includes(value);
  };
}
function isNullable(guard) {
  return function(value) {
    return value === null || guard(value);
  };
}
function isUndefinable(guard) {
  return function(value) {
    return value === void 0 || guard(value);
  };
}
function isOptional(guard) {
  return function(value) {
    return value == null || guard(value);
  };
}
function isNonNullable(val) {
  return val != null;
}
function isArray(value) {
  return Array.isArray(value);
}
function isArrayOf(guard) {
  return function(value) {
    return Array.isArray(value) && value.every(guard);
  };
}
function isNonEmptyArray(value) {
  return Array.isArray(value) && value.length >= 1;
}
function isNonEmptyArrayOf(guard) {
  return function(value) {
    return Array.isArray(value) && value.length >= 1 && value.every(guard);
  };
}
function isRecordOf(isA, isB) {
  return function(value) {
    return typeof value === "object" && !Array.isArray(value) && value != null && Object.keys(value).every(isA) && Object.values(value).every(isB);
  };
}
function isTupleOf(...tupleGuards) {
  return (value) => Array.isArray(value) && value.length === tupleGuards.length && tupleGuards.every((guard, i) => guard(value[i]));
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  hasKey,
  hasKeyOfAnyType,
  hasOptionalKey,
  hasTypeTag,
  isArray,
  isArrayOf,
  isBoolean,
  isExactly,
  isInteger,
  isLabeled,
  isNonEmptyArray,
  isNonEmptyArrayOf,
  isNonNullable,
  isNull,
  isNullable,
  isNumber,
  isObject,
  isOneOf,
  isOptional,
  isRecordOf,
  isString,
  isTupleOf,
  isUndefinable,
  isUndefined,
  isUnion,
  isUnknown
});
//# sourceMappingURL=guard.js.map
